<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           :query-api=queryApi
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emStocktakingTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      with-custom-row-actions
                                      ignore-add
                                      edit-disable
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author Lidongxu
    // Date 2025-06-03 11:23:55

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import emUtils from "@/utils/emUtils";

    export default {
        name: "emStocktakingTaskListView",
        mixins: [emCommonListMixin, emCommonGotoMixin, emCustomVuexMixin],
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            },
            emCustomVuexMixin_filter() {
                return this.$route.query.taskBusinessType?"qualityFilter": "filter"
            },
            queryApi() {
                return this.$route.query.taskBusinessType?"findQualityStockTaskTask": "findByFilter"
            }
        },
        methods: {
            gotoChild(row) {
                if (this.$route.query.taskBusinessType) {
                    this.emGotoMixin_gotoHolderListCustomer("emStocktakingTaskDetailQuality"
                            , "emStocktakingTaskDetail"
                            , {taskIdFilter: row.id}
                            , {taskCode: row.taskCode}
                            , false, {'taskBusinessType': this.$route.query.taskBusinessType})

                } else {
                    this.$_emGotoMixin_gotoHolderList("emStocktakingTaskDetail"
                            , {taskIdFilter: row.id}
                            , {taskCode: row.taskCode}
                            , false)
                }
            },
            /**
             * 跳转至列表页面 重写了方法
             * @param holderEntity
             * @param finalEntity
             * @param filterHolder
             * @param entityHolder
             * @param isInline
             * @param urlParam
             * @param queryApi
             * @param customVuexFilter
             * @param customVuexEntity
             * @param routerName
             */
            emGotoMixin_gotoHolderListCustomer(holderEntity, finalEntity, filterHolder, entityHolder, isInline, urlParam = {}, queryApi = "findByFilter", customVuexFilter = "filter", customVuexEntity = "entity", routerName) {
                //设置filterHolder
                this.$store.commit(`${holderEntity}/set${emUtils.toCapFirst(customVuexFilter)}Holder`, filterHolder)
                // console.log('设置filterHolder',`${holderEntity}/set${emUtils.toCapFirst(customVuexFilter)}Holder`, filterHolder)
                // console.log('当前filterHolder',this.$store.state[`${holderEntity}`][`${customVuexFilter}Holder`])
                //设置entityHolder
                this.$store.commit(`${holderEntity}/set${emUtils.toCapFirst(customVuexEntity)}Holder`, entityHolder)
                //清空除holder之外的查询条件
                this.$store.dispatch("emBase/emBaseClearFilter", {entity: holderEntity, filterState: customVuexFilter})
                        .then(() => {
                            //跳转:判断路由参数inline=1，如果是，跳转时也需要传递该参数
                            if ((this.$route.query.inline && this.$route.query.inline === "1") || isInline) {
                                this.$router.push({
                                    name: routerName ? routerName : `${holderEntity}List`,
                                    query: Object.assign({pathType: "fromParent", inline: "1"}, urlParam)
                                });
                            } else {
                                this.$router.push({
                                    name: routerName ? routerName : `${holderEntity}List`
                                    , query: Object.assign({pathType: "fromOtherList"}, urlParam)
                                });
                            }
                        }).then(() => {
                    // console.log('查询前filterHolder',this.$store.state[`${holderEntity}`][`${customVuexFilter}Holder`])
                    this.$store.dispatch("emBase/emBaseQueryByFilter", {entity: finalEntity, customVuexFilter, queryApi})
                })
            },
        },
    };
</script>
